import { useFilterSearchParams } from 'pages/Shipments/Containers/utilities';
import * as React from 'react';
import { Checkbox } from 'components/tailwind-ui/Checkbox';
import { Section } from './Section';

const HOLD_OPTIONS: { label: string; value: string }[] = [
  { label: 'All holds', value: 'all' },
  { label: 'Custom hold', value: 'customs' },
  { label: 'Freight hold', value: 'freight' },
  { label: 'Line hold', value: 'line' },
  // { label: 'USDA hold', value: 'usda' },
  { label: 'TMF hold', value: 'tmf' },
  { label: 'Term. hold', value: 'terminal' },
  { label: 'Other hold', value: 'others' },
];

export const Holds: React.FC = () => {
  const { searchParams, setSearchParams } = useFilterSearchParams(true);

  const filterStates = searchParams.holdTypes;

  const handleOnChange = (holdType: string, v: boolean) => {
    let newFilterStates = filterStates;
    if (holdType === 'all') {
      if (v) {
        newFilterStates = ['all'];
      } else {
        newFilterStates = [];
      }
    } else {
      newFilterStates = newFilterStates.filter((hold: string) => hold !== 'all');
      if (v) {
        newFilterStates.push(holdType);
      } else {
        newFilterStates = newFilterStates.filter((hold: string) => hold !== holdType);
      }
    }
    setSearchParams({
      holdTypes: newFilterStates,
    });
  };

  return (
    <Section title="Hold filters">
      <div className="flex">
        {HOLD_OPTIONS.map(({ label, value }) => (
          <Checkbox
            id={`hold-filter-${value}`}
            label={label}
            key={value}
            checked={filterStates.includes(value)}
            onCheck={(checked: boolean) => handleOnChange(value, checked)}
            className="mr-8"
          />
        ))}
      </div>
    </Section>
  );
};
Holds.displayName = 'Filters.More.Holds';
